"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasNoData;
function hasNoData(noDataValue, pixel) {
  return pixel.includes(noDataValue);
}